export enum DateType {
  Position = 'position',
  End = 'end',
}

export interface Position {
  dataType?: DateType;
  registrationNumber?: string;
  employeeName?: string;
  jobDescription?: string;
  warningId?: string;
}

interface Details {
  page: number;
  shiftStartTime: string;
  positions: Position[];
}

interface Warning {
  warningId: string;
  warning: string;
}

export interface IWarningItem {
  page: number;
  warning: Warning[];
}

export interface SlipDetails {
  title: string;
  subTitle: string;
  slipColour: string;
  location: string;
  orderDate: string;
  vessel: string;
  dock: string;
  quantityOrdered: number;
  job: string;
  isDock: boolean;
  isShip: boolean;
  isWheat: boolean;
  isDirtyCargo: boolean;
  isFreezer: boolean;
  isHides: boolean;
  isOffensive: boolean;
  details: Details[];
  replacmentTransfer: { page: number; details: string[] }[];
  warnings: IWarningItem[];
  nonDefaultWarnings: string;
  defaultWarnings: string;
}

export interface IDespatchSlipData {
  slipDetails: SlipDetails;
}